export default "__VITE_ASSET__7J2PKq0a__"